export default __webpack_public_path__ + "static/media/flask.4b252ba2.svg";